import { UserLogin } from './../../../../models/cms/user-login';
import { ValidationService } from './../../../../services/core/validation.service';
import { LoginService } from './../../../../services/cms/login.service';
//Angular
import { Component, OnInit, ViewContainerRef, Input, Compiler, Inject, ViewChild, ElementRef } from "@angular/core";
import { ComponentHelperService } from '../../../../services/core/component-helper.service';
import { CheckIfExistService } from "../../../../services/cms/check-existence.service";
import { Subscription } from "rxjs";
import { RoutesService } from "../../../../services/core/routes.service";
import { Router, ActivatedRoute } from "@angular/router";
import { QuickRegister } from "../../../../models/cms/register";
import { Configuration } from '../../../../models/core/configuration';
import { LanguageService } from '../../../../services/cms/language.service';
import { ConfigurationService } from '../../../../services/core/configuration.service';
import { CompanyService } from '../../../../services/core/company.service';
import { CookieService } from '../../../../services/core/cookie';
import { AuthService } from '../../../../services/core/auth.service';
import { HeaderService } from '../../../../services/cms/header.service';
import { Company } from '../../../../models/core/company';

@Component({
    selector: "dy-quick-register",
    template: ""
})

export class QuickRegistrationComponent implements OnInit {

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            @Inject('isBrowser') private isBrowser: boolean
        ) { }

    @Input() parentWidgetData: any;
    @Input() companyInfo: Company;

    ngOnInit() {
        if (!this.isBrowser)
            return;
            
        if (this.parentWidgetData != null) {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentWidgetData, this.companyInfo);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    }

    private createSubComponent(quickRegistrationData: any, companyInfo: Company) {

        @Component({
            template: quickRegistrationData.TemplateHtml
        })

        class ChildComponent implements OnInit {

            constructor
                (
                    @Inject('isBrowser') private isBrowser: boolean,
                    private loginService: LoginService,
                    private checkExists: CheckIfExistService,
                    private router: Router,
                    private routesService: RoutesService,
                    private activeRoute: ActivatedRoute,
                    private languageService: LanguageService,
                    private companyService: CompanyService,
                    private configurationService: ConfigurationService,
                    @Inject('CookieService') private cookie: CookieService,
                    private validationService: ValidationService,
                    private authService: AuthService,
                    private headerService: HeaderService
                ) { }

            private pageIsInit: boolean = false;

            //-- Email controls
            public isEmailValid: boolean = false;
            public emailExists: boolean = false;

            //-- Partita iva controls
            public isPivaValid: boolean = false;
            public pivaExists: boolean = false;

            //-- Codice Fiscale controls
            public isCFValid: boolean = false;
            public CFExists: boolean = false;

            private isRegisterFailed: boolean;
            private pageFrom: string = "";
            public load: boolean = false;

            private subManager = new Subscription();

            modelRegistration = new QuickRegister();
            configuration: Configuration;
            lang: string = this.languageService.getLongLang();
            company: Company = companyInfo;
            oldGroup: string;

            @ViewChild('submitButton') submitButton: ElementRef;

            ngOnInit() {
                let paramsSub = this.activeRoute.params.subscribe(params => {
                    let paramPageFrom = params['pagefrom'];

                    if (paramPageFrom !== undefined) {
                        this.pageFrom = paramPageFrom;
                    }
                });

                this.subManager.add(paramsSub);

                //-- Get configuration from server
                this.setConfiguration();
            }

            finishQuickRegistration() {
                this.load = true;
                //-- After submiting form, we are disabling a button until we get a response
                this.submitButton.nativeElement.disabled = true;

                let quickRegisterUserObj = this.setQuickRegisterObject();

                //-- Save quick registration user info in cookies so we can reuse it later
                this.cookie.putObject("QuickRegisterUser", quickRegisterUserObj);
                let isQuickRegister: boolean = true;

                this.cookie.put('IsQuickRegistered', isQuickRegister.toString());

                let sendInfoSub = this.loginService.quickRegister(this.modelRegistration)
                    .subscribe(response => {
                        this.load = false;
                        this.hideModalQuickRegistration();

                        if (response.Id_User_Dettail > 0 && response.Active) {
                            let name = response.Name ? response.Name : response.Email;
                            this.authService.Login(response.Id_User_Dettail, name);
                        }

                        if (response.IsCompletedRegistration == false) {
                            if (response.Active) {
                                let user = new UserLogin();
                                user.isAuthenticated = true;
                                user.username = response.Name ? response.Name : response.Email;

                                //-- Call service to update header info, to set a logged in user
                                this.headerService.setLoggedInUser(user);

                                //-- Hide quick registration component even after user is logged in, because we want to show an additional dialog modal
                                this.headerService.setToShowQuickRegistration(true);

                                this.showQuickRegistrationSuccessModal();
                                // let navigationExtras: NavigationExtras = {
                                //     queryParams: { 'quickRegistration': true }
                                // };
                                // this.router.navigate([this.routesService.getRoutePath('REGISTRAZIONE')[0]], navigationExtras);
                            }
                        }
                        else if (this.pageFrom == "cart") {
                            this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                        }
                        else {
                            this.router.navigate(this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));
                        }
                    }
                    )

                this.subManager.add(sendInfoSub);
            }

            setQuickRegisterObject() {
                let quickRegisterObj = {
                    QuickEmailUser: this.modelRegistration.EmailRegister.trim(),
                    QuickPartitaIva: this.modelRegistration.PartitaIva.trim(),
                    QuickCodiceFiscale: this.modelRegistration.CodiceFiscale.trim(),
                    QuickClientType: this.modelRegistration.CustomerGroup.trim(),
                    QuickTelephone: this.modelRegistration.Telephone.trim(),
                }

                return quickRegisterObj;
            }

            quickRegister() {
                if (this.isEmailValid) {
                    this.hideModalQuickRegistrationEmail();
                    this.showModalQuickRegistration();
                }
            }

            //-- Checking after changing of focus if the email entered in form already exists in database
            checkEmail(form) {
                if (form.controls.EmailRegister.valid) {
                    let checkEmailSub = this.checkExists.checkIfEmailExistsInDb(this.modelRegistration.EmailRegister)
                        .subscribe(result => {
                            if (result == 1) {
                                this.isEmailValid = true;
                                this.emailExists = false;
                            }
                            else {
                                this.isEmailValid = false;
                                this.emailExists = true;
                            }
                        })

                    this.subManager.add(checkEmailSub);
                }
                else {
                    this.isEmailValid = false;
                    this.emailExists = false;
                }
            }

            //-- Checking after changing of focus if the partita iva entered in form already exists in database
            checkPiva(field) {
                if (field.valid) {
                    if (!field.value || !field.value.trim())
                        return;

                    this.checkExists.checkIfPartitaIvaExistsInDb(this.modelRegistration.PartitaIva)
                        .subscribe(result => {
                            if (result == 1) {
                                this.isPivaValid = true;
                                this.pivaExists = false;
                            }
                            else {
                                if (this.modelRegistration.CustomerGroup !== '7') {
                                    this.isPivaValid = false;
                                    this.pivaExists = true;
                                }
                                else {
                                    this.isPivaValid = true;
                                    this.pivaExists = false;
                                }
                            }
                        })
                }
                else {
                    if (this.modelRegistration.CustomerGroup !== '7') {
                        this.isPivaValid = false;
                        this.pivaExists = false;
                    }
                    else {
                        this.isPivaValid = true;
                        this.pivaExists = false;
                    }
                }
            }

            //-- Checking after changing of focus if the codice fiscale entered in form already exists in database
            checkCF(field) {
                if (!field.valid) {
                    this.isPivaValid = false;
                    this.pivaExists = false;
                }

                //-- Check if the CF already exists only when group is privato
                if (this.modelRegistration.CustomerGroup === '4') {
                    if (field.valid) {
                        this.checkExists.checkIfCodiceFiscaleExistsInDb(this.modelRegistration.CodiceFiscale)
                            .subscribe(result => {
                                {
                                    if (result == 1) {
                                        this.isCFValid = true;
                                        this.CFExists = false;
                                    }
                                    else {
                                        this.isCFValid = false;
                                        this.CFExists = true;
                                    }
                                }
                            })
                    }
                }
                else {
                    this.isCFValid = true;
                    this.CFExists = false;
                }
            }

            //validation of phone numbers, disable writing any characters in input except of numbers
            validatePhone(event: any) {
                this.validationService.validatePhoneNumber(event);
            }

            setConfiguration() {
                this.configurationService.getConfiguration(this.lang).subscribe(resultConfiguration => {
                    let companySub = this.companyService.getCompany().subscribe(resultCompany => {
                        {
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}').join(resultCompany.Name);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}').join(resultCompany.StreetAddress);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}').join(resultCompany.PostalCode);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}').join(resultCompany.City);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}').join(resultCompany.Province);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}').join(resultCompany.Phone);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}').join(resultCompany.Email);
                            }
                        }

                        this.configuration = resultConfiguration;
                    });

                    this.subManager.add(companySub);
                });
            }


            onCustomerGroupChange(value) {
                this.setValuesOnCustomerGroupChange();
                this.modelRegistration.CustomerGroup = value;

                if (this.modelRegistration.CustomerGroup == '4' || this.modelRegistration.CustomerGroup == '7') {
                    this.isPivaValid = true;
                }
                else {
                    this.isCFValid = true;
                }
            }

            saveOldGroup()
            {
                this.oldGroup = this.modelRegistration.CustomerGroup;
            }

            setValuesOnCustomerGroupChange() {
                this.modelRegistration = new QuickRegister(this.modelRegistration.EmailRegister,
                    this.modelRegistration.EmailRepeat,
                    this.modelRegistration.Password,
                    this.modelRegistration.Telephone,
                    this.modelRegistration.CustomerGroup,
                    this.modelRegistration.CodiceFiscale,
                    this.modelRegistration.PartitaIva, this.oldGroup);
            }

            resetForm() {
                this.modelRegistration = new QuickRegister(this.modelRegistration.EmailRegister);
            }

            //-- Hiding and showing corresponding modals
            showModalQuickRegistration() {
                this.showModal('quickRegistrationModal');
            }

            hideModalQuickRegistration() {
                this.hideModal('quickRegistrationModal');

                this.modelRegistration.EmailRegister = '';
                this.resetForm();
            }

            showModalQuickRegistrationEmail() {
                this.showModal('quickRegistrationEmailModal');
            }

            showQuickRegistrationSuccessModal()
            {
                this.showModal('quickRegistrationSuccessModal');
            }

            hideQuickRegistrationSuccessModal()
            {
                this.hideModal('quickRegistrationSuccessModal');
                //-- Hide quick registration component
                this.headerService.setToShowQuickRegistration(false);
            }

            hideModalQuickRegistrationEmailAndResetEmail() {
                this.hideModalQuickRegistrationEmail();
                this.modelRegistration.EmailRegister = '';
            }

            hideModalQuickRegistrationEmail() {
                this.hideModal('quickRegistrationEmailModal');
            }

            showModal(modalId: string) {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                (document.querySelector('#header') as HTMLElement).style.zIndex = '1041';
                $(`#${modalId}`).modal("show");
            }

            hideModal(modalId: string) {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                (document.querySelector('#header') as HTMLElement).style.zIndex = '1041';
                $(`#${modalId}`).modal("hide");
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/user/sys/quick-registration.component.ts